<template>
    <div class="builtWithRiv dashboard_root">
        <loadercomp v-if="$store.state.loader" />
        <div class="builtWithRiv_wrap">
            <div class="builtWithRiv_wrap_header">
                <h2>Buitl With Rivet</h2>
                <p>
                    Complete this form to apply for “Buitl with Rivet” discounts. We’ll review your application and be in touch as soon as we can. (If
                    you have questions, please reach out at <a href="mailto:concierge@rivet.cloud">concierge@rivet.cloud</a>.)
                </p>
            </div>
            <form @submit.prevent="submitForm" class="builtWithRiv_wrap_form">
                <div class="input-opensource builtWithRiv_wrap_form_input">
                    <div class="builtWithRiv_wrap_form_input_select">
                        <div class="builtWithRiv_wrap_form_input_select_inner">
                            <label for="input-opensource-val">Is your project open source?</label>
                            <select class="dashboard_select" name="OpenSource" id="input-opensource-val">
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>
                    </div>
                    <div class="input-opensource builtWithRiv_wrap_form_input">
                        <label for=""> If Yes, provide a link to a github repository </label>
                        <input name="Github" type="text" placeholder="https://github.com/openrelayxyz/plugeth" />
                    </div>
                </div>

                <div class="input-sm builtWithRiv_wrap_form_input">
                    <div class="builtWithRiv_wrap_form_input_select">
                        <div class="builtWithRiv_wrap_form_input_select_inner">
                            <label for="input-sm-val">Do you have a presence on social media?</label>
                            <select class="dashboard_select" name="Social Media?" id="input-sm-val">
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>
                    </div>
                    <div class="input-sm builtWithRiv_wrap_form_input">
                        <label for="social-media-urls"> If Yes, provide links to your social media accounts </label>
                        <textarea name="Social media links" id="social-media-urls" cols="30" rows="5"></textarea>
                    </div>
                </div>

                <div class="input-blockchain builtWithRiv_wrap_form_input">
                    <div class="builtWithRiv_wrap_form_input_select">
                        <div class="builtWithRiv_wrap_form_input_select_inner">
                            <label for="input-dec">Does (or will) your project have a token or other smart-contract-powered functionality?</label>
                            <select class="dashboard_select" name="Token or smart contract functionality" id="input-dec">
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>
                    </div>
                    <div class="input-blockchain builtWithRiv_wrap_form_input">
                        <label for="blockexplorerurl">If Yes, enter block explorer link list</label>
                        <input
                            name="Block explorer link"
                            type="text"
                            id="blockexplorerurl"
                            placeholder="e.g https://blockexplorerscan.com/address/0xA0b86991c621b0cE3606eB48"
                        />
                    </div>
                </div>

                <div class="input-name builtWithRiv_wrap_form_input">
                    <label for="input-name">Enter name of primary contact</label>
                    <input autocomplete="name" required name="Name" type="text" id="input-name" placeholder="Brad Joseph" />
                </div>
                <div class="input-email builtWithRiv_wrap_form_input">
                    <label for="email"> Enter Email of primary contact</label>
                    <input required autocomplete="email" name="Email" type="text" id="input-email" placeholder="bradjoseph@rivet.cloud" />
                </div>
                <div class="builtWithRiv_wrap_form_input input-extras">
                    <label for=""
                        >Is there anything else you want to tell us about why your project is awesome/world-changing/cypherpunk AF? (optional)</label
                    >
                    <textarea name="Extra info" id="" rows="7"></textarea>
                </div>
                <div class="submit_btn btn_color btn_long">
                    <button type="submit">Submit Application</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
import loadercomp from "@/components/loadercomp";
import { useStore } from "vuex";
import Swal from "sweetalert2";
import router from "../../router";
const store = useStore();

const submitForm = (e) => {
    store.commit("toggleLoader");
    const data = new FormData(e.target);
    console.log(data);
    fetch("https://script.google.com/macros/s/AKfycbztMblOyuxKjR5to3sCbyeOaE5Ag-EwFrull_rFuwTILsLYJ0RIHxLytx41Ogam62duiA/exec", {
        method: "POST",
        body: data,
    })
        .then((res) => {
            if (res.ok) {
                e.target.reset();
                store.commit("toggleLoader");
                Swal.fire({
                    icon: "success",
                    titleText: "Success",
                    text: `

                    Application submitted

                    `,
                    confirmButtonColor: "#417dd8",
                    confirmButtonText: "Continue",
                });
                router.push({ name: "overview" });
            } else {
                Swal.fire({
                    icon: "error",
                    titleText: "Error",
                    text: `
                  Uknown error occured. Please try again
                `,
                    confirmButtonColor: "#417dd8",
                    confirmButtonText: "Continue",
                });
            }
        })
        .catch((error) => console.error(error));
};
</script>

<style lang="scss">
.builtWithRiv {
    label {
        display: block;
        font-size: 1.1em;
    }
    select {
        display: inline-block;
    }
    &_wrap {
        width: 85%;
        margin: 0 auto;
        @include flex_col(2.5rem 0rem);
        &_header {
            @include flex_col(1rem 0rem);
        }
        &_form {
            @include flex_col(1.5rem 0px);
            &_input {
                @include flex_col(0.6rem);
                &_select {
                    display: list-item;
                    &_inner {
                        @include flex(flex-start, center, 1rem);
                    }
                }
            }
        }
    }
}
</style>
